import { fetcher } from "../fetcher";

type GetSettlementsStagesParams = {
  client_project_id: number;
  with?: ("settlements" | "settlements.payments")[];
  order_direction?: "asc" | "desc";
};

type GetSettlementsParams = {
  client_project_id: number;
  order_by?:
    | "id"
    | "name"
    | "amount"
    | "payment_due_date"
    | "status"
    | "order"
    | "created_at"
    | "updated_at";
  order_direction?: "asc" | "desc";
  per_page?: string;
  status?: "paid" | "to_pay";
};

type GetAllSettlementsParams = {
  client_project_id: number;
  order_by?:
    | "id"
    | "name"
    | "amount"
    | "payment_due_date"
    | "status"
    | "order"
    | "created_at"
    | "updated_at";
  order_direction?: "asc" | "desc";
};

type GetPaymentsParams = {
  client_project_id: number;
  order_by?:
    | "id"
    | "amount"
    | "payment_date"
    | "status"
    | "created_at"
    | "updated_at";
  order_direction?: "asc" | "desc";
};

export const settlementsService = {
  getSettlementStages: async (params?: GetSettlementsStagesParams) => {
    return await fetcher(`/settlement-stages/all`, {
      method: "GET",
      params,
      schema: settlementStagesSchema,
    });
  },
  getSettlements: async (params?: GetSettlementsParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("payment_due_date" as const),
    };

    return await fetcher(`/settlements/all`, {
      method: "GET",
      params: paramsWithDefaults,
      // schema: settlementsSchema,
    });
  },
  getAllSettlements: async (params?: GetAllSettlementsParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("payment_due_date" as const),
    };

    return await fetcher(`/settlements/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: settlementsSchema,
    });
  },
  getPayments: async (params?: GetPaymentsParams) => {
    const paramsWithDefaults = {
      ...params,
      order_by: params?.order_by ?? ("payment_date" as const),
    };

    return await fetcher(`/payments/all`, {
      method: "GET",
      params: paramsWithDefaults,
      schema: paymentsSchema,
    });
  },
};
